"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rangeValues = exports.paymentStatuses = exports.requestTypes = void 0;
const moment_1 = __importDefault(require("moment"));
const requestTypes = [
    {
        key: 'app',
        value: 'Appearance'
    },
    {
        key: 'dep',
        value: 'Deposition'
    },
    {
        key: 'fatt',
        value: 'Freelance Task'
    },
    {
        key: 'rc',
        value: 'Refer Case'
    },
    {
        key: 'cons',
        value: 'Consumer Case'
    },
    {
        key: 'invite',
        value: 'Invite Friend'
    }
];
exports.requestTypes = requestTypes;
const paymentStatuses = [
    {
        key: 4,
        value: 'IRS Pending'
    },
    {
        key: 3,
        value: 'Received'
    },
    {
        key: 2,
        value: 'Canceled'
    },
    {
        key: 'pending',
        value: 'Pending'
    },
    {
        key: 'paid',
        value: 'Paid'
    }
];
exports.paymentStatuses = paymentStatuses;
const rangeValues = [
    {
        value: 'Select Range',
        from: moment_1.default('1970-01-01 00:00Z').format('YYYY-MM-DD'),
        to: moment_1.default().format('YYYY-MM-DD')
    },
    {
        value: 'This Month',
        from: moment_1.default().startOf('month').format('YYYY-MM-DD'),
        to: moment_1.default().endOf('month').format('YYYY-MM-DD')
    },
    {
        value: 'Last Month',
        from: moment_1.default().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
        to: moment_1.default().subtract(1, 'months').endOf('month').format('YYYY-MM-DD')
    },
    {
        value: 'This Year',
        from: moment_1.default().startOf('year').format('YYYY-MM-DD'),
        to: moment_1.default().endOf('year').format('YYYY-MM-DD')
    },
    {
        value: 'Last Year',
        from: moment_1.default().subtract(1, 'years').startOf('year').format('YYYY-MM-DD'),
        to: moment_1.default().subtract(1, 'years').endOf('year').format('YYYY-MM-DD')
    }
];
exports.rangeValues = rangeValues;
